import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box } from "@mui/material";
import React, { useContext } from "react";

import { BoundingBoxesContext, BoundingBoxesContextType } from "context/boundingBoxesContext";

export function StepNavigation() {
  const { stepsData, handleChangeSteps, validBoxLabels } = useContext(BoundingBoxesContext) as BoundingBoxesContextType;

  const { currentStep, totalSteps } = stepsData;

  const isPreviousStepAvailable = currentStep > 1;
  const isNextStepAvailable = currentStep <= totalSteps;
  const currentBoxes = validBoxLabels[currentStep - 1];
  const currentLabelColor = currentBoxes?.color || "#4ca1e9";
  const currentLabel = currentBoxes?.label || "label";

  return (
    <Box
      sx={{
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 10px",
        backgroundColor: currentLabelColor,
      }}
    >
      <ArrowBackIosNewIcon
        onClick={() => {
          if (isPreviousStepAvailable) {
            handleChangeSteps(currentStep - 1);
          }
        }}
        className={`text-white cursor-pointer ${!isPreviousStepAvailable && "invisible"}`}
      />

      {
        currentStep <= totalSteps &&
        <p className="flex items-center uppercase gap-[5px]">
          <span className="font-semibold text-[14px] leading-[24px] font-weight-[600] text-[#ffffff]">
            {`Task ${currentStep}: `}
          </span>
          <span className="font-semibold text-[20px] leading-[24px] font-weight-[700] text-[#ffffff]">
            {`Draw a ${currentBoxes.type} around every ${currentLabel}`}
          </span>
        </p>
      }
      {
        currentStep === totalSteps + 1 && (
          <p className="flex items-center uppercase gap-[5px]">
            <span className="font-semibold text-[14px] leading-[24px] font-weight-[600] text-[#ffffff]">
              {`Task ${currentStep}: `}
            </span>
            <span className="font-semibold text-[20px] leading-[24px] font-weight-[700] text-[#ffffff]">
              Answer query
            </span>
          </p>
        )
      }

      <ArrowForwardIosIcon
        onClick={() => {
          if (isNextStepAvailable) {
            handleChangeSteps(currentStep + 1);
          }
        }}
        className={`text-white cursor-pointer ${!isNextStepAvailable && "invisible"}`}
      />
    </Box>
  );
}
